import { useMemo } from 'react';
import { Column } from 'react-table';
import { ICustomsDeclaration } from '../../interfaces';
import { nextTableColumns, nextTableColumnGenerator } from '@shared/modules/next-table/helpers/next-table-columns';
import { OverCell } from '@shared/components/cells';
import { UserCell } from '@modules/users';
import { customsDeclarationPersistenceKeys } from '../../utils';

export const useCustomsDeclarationsTableColumns = (): Column<ICustomsDeclaration>[] => {
  return useMemo<Column<ICustomsDeclaration>[]>(
    () => [
      {
        ...nextTableColumnGenerator(140, 'px'),
        accessor: (row) => row.regNumber,
        id: customsDeclarationPersistenceKeys.regNumber,
        Header: 'Qeydiyyat nömrəsi',
      },
      {
        ...nextTableColumns.small,
        accessor: (row) => row.user?.id,
        id: customsDeclarationPersistenceKeys.user.id,
        Header: 'M. kodu',
      },
      {
        accessor: (row) => row.user?.name,
        id: customsDeclarationPersistenceKeys.user.name,
        Header: 'Müştəri',
        Cell: ({ row: { original } }: any) => (original.user ? <UserCell id={original.user.id} title={original.user.name} /> : null),
      },
      {
        accessor: (row) => row.importer.name,
        id: customsDeclarationPersistenceKeys.importer.name,
        Header: 'İdxalçı',
        Cell: OverCell,
        width: 200,
      },
      {
        ...nextTableColumns.small,
        accessor: (row) => row.importer.passportSecret,
        id: customsDeclarationPersistenceKeys.importer.passportSecret,
        Header: 'FİN kod',
      },
      {
        ...nextTableColumns.small,
        accessor: (row) => row.trackingNumber,
        id: customsDeclarationPersistenceKeys.trackingNumber,
        Header: 'İzləmə kodu',
      },
      {
        ...nextTableColumns.normal,
        accessor: (row) => row.productType,
        id: customsDeclarationPersistenceKeys.productType,
        Header: 'Malın təsviri',
        Cell: OverCell,
      },
      {
        ...nextTableColumns.small,
        accessor: (row) => row.quantity,
        id: customsDeclarationPersistenceKeys.quantity,
        Header: 'Malın miqdarı',
        Cell: ({ cell: { value } }: any) => `${value} ədəd`,
      },
      {
        accessor: (row) => row.invoicePrice.original,
        id: customsDeclarationPersistenceKeys.invoicePrice.original,
        Header: 'İnvoys qiyməti',
      },
      {
        accessor: (row) => row.invoicePrice.usd,
        id: customsDeclarationPersistenceKeys.invoicePrice.usd,
        Header: 'İnvoys qiyməti (USD)',
      },
      {
        accessor: (row) => row.paymentStatus,
        id: customsDeclarationPersistenceKeys.paymentStatus,
        Header: 'Status',
      },
      {
        ...nextTableColumns.date,
        accessor: (row) => row.createdAt,
        id: customsDeclarationPersistenceKeys.createdAt,
        Header: 'Yaradılma tarixi',
      },
    ],
    [],
  );
};
